import React from 'react';

interface DragDotsIconProps {
  className?: string;
}

const DragDotsIcon: React.FC<DragDotsIconProps> = ({ className }) => (
  <svg
    viewBox="0 0 12 12"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="2" cy="2" r="1.5" />
    <circle cx="6" cy="2" r="1.5" />
    <circle cx="10" cy="2" r="1.5" />
    <circle cx="2" cy="6" r="1.5" />
    <circle cx="6" cy="6" r="1.5" />
    <circle cx="10" cy="6" r="1.5" />
    <circle cx="2" cy="10" r="1.5" />
    <circle cx="6" cy="10" r="1.5" />
    <circle cx="10" cy="10" r="1.5" />
  </svg>
);

export default DragDotsIcon;
